import { Overlay, Wrapper, Header } from './styled'
import types from './types'

const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

const SettingsModal = props => {
  const Settings = types[props.type]

  const headerTitle = {
    col: `Column ${alphabet[props.colIdx]}`,
    cell: `Cell ${alphabet[props.cellIdx]}${props.rowIdx + 1}`
  }[props.type]

  return (
    <Overlay>
      <Wrapper>
        <Header>{headerTitle}</Header>
        <Settings {...props} />
      </Wrapper>
    </Overlay>
  )
}

export default SettingsModal